// const baseUrl = "http://localhost:3030/api";
// const baseUrl = "https://ssopl.fly.dev/api";
const baseUrl = "https://api.ssopl.org/api";
// const baseUrl = "https://ssolpapi.fly.dev/api";

export default baseUrl;
